// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__XmIVB","subheader":"ReorderModal_subheader__1kyQF","listWrap":"ReorderModal_listWrap__1nt-J"};